/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';

/**
 * 
 * @export
 * @interface CreateOrUpdateProtocolDto
 */
export interface CreateOrUpdateProtocolDto {
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateProtocolDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateProtocolDto
     */
    dateOfPublication: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateProtocolDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateProtocolDto
     */
    publisher: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateProtocolDto
     */
    references?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOrUpdateProtocolDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof CreateOrUpdateProtocolDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateProtocolDto
     */
    $type?: CreateOrUpdateProtocolDtoTypeEnum;
}


/**
 * @export
 */
export const CreateOrUpdateProtocolDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedProtocolsDtoCreateOrUpdateProtocolDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Protocols.Dto.CreateOrUpdateProtocolDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateOrUpdateProtocolDtoTypeEnum = typeof CreateOrUpdateProtocolDtoTypeEnum[keyof typeof CreateOrUpdateProtocolDtoTypeEnum];



/**
 * Check if a given object implements the CreateOrUpdateProtocolDto interface.
 */
export function instanceOfCreateOrUpdateProtocolDto(value?: unknown): value is CreateOrUpdateProtocolDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateOrUpdateProtocolDtoTypeEnum)[0];
}

export function CreateOrUpdateProtocolDtoFromJSON(json: any): CreateOrUpdateProtocolDto {
    return CreateOrUpdateProtocolDtoFromJSONTyped(json, false);
}

export function CreateOrUpdateProtocolDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrUpdateProtocolDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'dateOfPublication': json['dateOfPublication'],
        'description': json['description'] == null ? undefined : json['description'],
        'publisher': json['publisher'],
        'references': json['references'] == null ? undefined : json['references'],
        'isAvailable': json['isAvailable'] == null ? undefined : json['isAvailable'],
        'attachments': json['attachments'] == null ? undefined : ((json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function CreateOrUpdateProtocolDtoToJSON(value?: CreateOrUpdateProtocolDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'name': value['name'],
        'dateOfPublication': value['dateOfPublication'],
        'description': value['description'],
        'publisher': value['publisher'],
        'references': value['references'],
        'isAvailable': value['isAvailable'],
        'attachments': value['attachments'] == null ? undefined : ((value['attachments'] as Array<any>).map(FileMetaInfoDtoToJSON)),
        '$type': value['$type'],
    });
}

